import React, { forwardRef } from 'react';
import { Provider } from 'react-redux';
import { store } from "../../../model";
import { ConfigWrapper } from "../../../ui";
export var withStoreProvider = function withStoreProvider(WrappedComponent) {
  return /*#__PURE__*/forwardRef(function (props, ref) {
    var Component = WrappedComponent;
    return /*#__PURE__*/React.createElement(Provider, {
      store: store
    }, /*#__PURE__*/React.createElement(ConfigWrapper, props, /*#__PURE__*/React.createElement(Component, {
      enableQueriesParams: props.enableQueriesParams,
      isOpen: props.isOpen,
      onChatOpen: props.onChatOpen,
      ref: ref
    })));
  });
};